import {
    addCounterStates
} from "../utils/reducerUtils";
import {
    IMPORT_ICAL_RESET_REQUEST,
    IMPORT_ICAL_TERMINE,
    IMPORT_ICAL_TERMINE_FAILURE,
    IMPORT_ICAL_TERMINE_SUCCESS,
    SKIP_IMPORT_ICAL_TERMINE
} from "./terminActions";

const INITIAL = {};

export const TERMIN_DATA_NAME = 'terminData'

export default function terminReducers(state = INITIAL, action) {
    switch (action.type) {
        

        case IMPORT_ICAL_TERMINE:
                return {
                    ...state,
                    iCalTermineImporting: true
                }
        case IMPORT_ICAL_TERMINE_SUCCESS:
        case IMPORT_ICAL_TERMINE_FAILURE:
        case SKIP_IMPORT_ICAL_TERMINE:
            return {
                ...state,
                iCalTermineImporting: state.iCalTermineImporting && false,
                iCalTermineCounters: addCounterStates(state.iCalTermineCounters, action.payload.icalImportCounters)
            }

        case IMPORT_ICAL_RESET_REQUEST:
            return INITIAL

        

        default:
            return state;
    }
}
